import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faThumbsUp, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../components/MainHeader/MainHeader.js'
import MainFooter from '../../components/MainFooter/MainFooter.js'
import CTAButton from '../../components/CTAButton/CTAButton.js'

import { lP, boxvar2_1, URL_MAINAPI, API_TOKEN } from '../../main.js'

import '../../main.css'
import './VerifyNewEmail.css'
import './MVerifyNewEmail.css'

import Cookies from 'universal-cookie'
const cookies = new Cookies()

export default function VerifyNewEmail() {

    var [verifyState, setVerifyState] = useState('loading')

    useEffect(() => {
        doVerify()
    }, [])

    function doVerify() {
        var urlParams = new URLSearchParams(window.location.search)
        var id = urlParams.get('userid')
        var verifytoken = urlParams.get('verifytoken')

        if (id == null || verifytoken == null) {
            setVerifyState('error')
            return
        }

        var reqbody = {
            "id": id, "verifytoken": verifytoken
        }

        try {
            fetch(URL_MAINAPI + "/user/verifynewemail", {
                method: "PATCH",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                body: JSON.stringify(reqbody),
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    if (res.data && res.data.authtoken) {
                        cookies.set('userid', res.data.userid, { path: '/' })
                        cookies.set('authtoken', res.data.authtoken, { path: '/' })
                    }
                    setVerifyState('done')
                } else {
                    setVerifyState('error')
                }
            }))
        } catch (err) {
            setVerifyState('error')
        }
    }

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>E-Mail-Änderung bestätigen</title>
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body'>
                <div className='auth-wrap'>
                    <div className='auth-head'>
                        <div className='section-eyebrow'>E-Mail-Änderung</div>
                        <h1>Deine neue E-Mailadresse wird bestätigt...</h1>
                    </div>

                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <div className='card auth-card verifynewemail-card' style={{ maxWidth: '480px', margin: '0 auto', textAlign: 'center' }}>
                            {(verifyState === 'loading') ? (
                                <div>
                                    <h2><FontAwesomeIcon icon={faSpinner} spin style={{ color: 'var(--info)' }} /></h2>
                                    <p>Wird geladen... Bitte warten!</p>
                                </div>
                            ) : (verifyState === 'error') ? (
                                <div>
                                    <h2><FontAwesomeIcon icon={faTriangleExclamation} style={{ color: 'var(--error)' }} /></h2>
                                    <p>
                                        Es gab einen Fehler bei der Bestätigung deiner neuen E-Mailadresse!<br />
                                        Möglicherweise ist der Bestätigungslink ungültig oder abgelaufen.<br />
                                        Kontaktiere uns gerne, falls du Hilfe brauchst.
                                    </p>
                                    <CTAButton variant="primary" title="Zum Login" onclick={() => lP("/login")} />
                                </div>
                            ) : (
                                <div>
                                    <h2><FontAwesomeIcon icon={faThumbsUp} style={{ color: 'var(--success)' }} /></h2>
                                    <p>
                                        Deine neue E-Mailadresse wurde erfolgreich bestätigt!<br />
                                        Ab sofort nutze bitte die neue Adresse für die Anmeldung.
                                    </p>
                                    <CTAButton variant="secondary" title={"Zum Profil"} onclick={() => lP('/profil')} />
                                </div>
                            )}
                        </div>
                    </motion.div>
                </div>
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
